import styled from 'styled-components'
import Button from 'components/Button/Button'
import { themeGet } from 'styled-system'

export const BulkAssignButton = styled(Button)`
  margin: 5px;
  color: '#002855';
`

export const BulkAssignColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
`

export const BulkAssignLayoutSection = styled.div`
  display: flex;
`

export const BulkAssignLayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Instructions = styled.span`
  display: flex;
  font-family: Molde-bold;
  padding: 0.6rem 0;
`

export const ExampleImage = styled.img`
  display: flex;
  width: 100%;
`

export const UploadSection = styled.div`
  display: flex;
  padding: 1rem 0 0.5rem;

  & > div {
    display: flex;
    flex: 1;
  }

  & > div + div {
    justify-content: flex-end;
    align-items: baseline;
  }
`

interface ResultsWrapperProps {
  hasErrors: boolean
}

export const ResultsWrapper = styled.div<ResultsWrapperProps>`
  display: flex;
  flex-direction: column;
  color: ${props => (props.hasErrors ? 'red' : 'green')};
`

export const ErrorMessage = styled.div`
  margin-top: 0.25rem;
`

export const TemplateLinkWrapper = styled.div`
  a {
    color: ${themeGet('colors.blue')};
  }
`

export const ResultsSection = styled.div`
  margin-top: 1rem;
  padding: 1rem 0;
`

export const TableContainer = styled.div`
  margin-top: 1rem;
  max-height: 500px;
  overflow: auto;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
`

